import * as React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
} from '@mui/material';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import { useRef, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { t } from 'i18next';
import { useAppDispatch } from '../../redux_store/reduxStore';
import {
  addCategory,
  modifyCategory,
} from '../../redux_store/slices/categorySlice';
import {
  BakeasyButtonClose,
  BakeasyButtonCreate,
  BakeasyButtonUpdate,
} from '../../components/buttons/BakeasyButton';
import * as Dropdown from '../../components/dropdowns/BakeasySelect';
import { Close } from '@mui/icons-material';
import { validateField } from '../../utils/ValidationUtils';
import * as Regex from '../../constants/Regex';

export const AddEditCategory = (props: any) => {
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);
  const formRef = useRef<HTMLDivElement>(null);

  const [name, setName] = useState<string>('');
  const [description, setDescription] = useState<string>('');
  const [categoryId, setCategoryId] = useState<string>('');
  const [selectedStatus, setSelectedStatus] = useState<any>('');

  function handleClose() {
    myContext.setDialog({ open: false });
    props?.onBack();
  }

  const checkValidity = (): boolean => {
    if (!validateField(dispatch, 'CATEGORY_NAME', name, formRef, Regex.name)) {
      return false;
    }
    // if (!description) {
    // 	let msg = `${t("DESCRIPTION")} ${t("IS_REQUIRED")}`;
    // 	dispatch(showErrorSnackbar({ message: msg }));
    // 	return false;
    // }
    if (!validateField(dispatch, 'STATUS', selectedStatus, formRef)) {
      return false;
    }
    return true;
  };

  async function onAddSubmit() {
    if (!checkValidity()) {
      return;
    }
    let payload = {
      categoryName: name,
      description: description,
      status: selectedStatus,
    };
    await dispatch(addCategory(payload));
    handleClose();
  }

  async function onEditSubmit() {
    if (!checkValidity()) {
      return;
    }

    let payload = {
      id: categoryId,
      categoryName: name,
      ...(description && { description: description }),
      status: selectedStatus,
    };
    await dispatch(modifyCategory(payload));
    handleClose();
  }

  React.useEffect(() => {
    setName(props?.params?.name);
    setDescription(props?.params?.description);
    setSelectedStatus(props?.params?.status);
    setCategoryId(props?.params?.categoryId);
  }, []);

  return (
    <div ref={formRef}>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {props?.params?.isEdit ? t('EDIT_CATEGORY') : t('ADD_CATEGORY')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent sx={{ margin: 0 }}>
        <Grid item xs={12} sm={12}>
          <BakeasyTextField
            label={t('CATEGORY_NAME')}
            type="text"
            name="name"
            value={name}
            regexPattern={Regex.name}
            required={true}
            onChange={(event: any) => {
              setName(event.target.value);
            }}
            placeHolder={t('ENTER_CATEGORY_NAME')}
          />
        </Grid>

        <Grid item xs={12} sm={12} marginTop={1}>
          <BakeasyTextField
            label={t('DESCRIPTION')}
            placeHolder={t('ENTER_DESCRIPTION')}
            type="text"
            name="description"
            value={description}
            multiline
            maxLength={500}
            rows={4}
            onChange={(event: any) => {
              setDescription(event.target.value);
            }}
          />
        </Grid>

        <Grid item xs={12} sm={12} marginTop={1}>
          <Dropdown.Status
            label={t('STATUS')}
            placeholder={t('SELECT_STATUS')}
            size="small"
            required={true}
            fullWidth={true}
            value={selectedStatus}
            onChange={(event: any) => {
              setSelectedStatus(event.target.value);
            }}
          />
        </Grid>
      </DialogContent>

      <DialogActions sx={{ margin: 1 }}>
        <BakeasyButtonClose onClick={handleClose} />

        {props?.params?.isEdit ? (
          <BakeasyButtonUpdate
            onClick={() => {
              onEditSubmit();
            }}
          />
        ) : (
          <BakeasyButtonCreate
            onClick={() => {
              onAddSubmit();
            }}
          />
        )}
      </DialogActions>
    </div>
  );
};
